/**
 * Types of PII, adopted from the Aria framework's list.
 */
export var PiiKind;
(function (PiiKind) {
    /**
     * No kind.
     */
    PiiKind[PiiKind["NotSet"] = 0] = "NotSet";
    /**
     * An LDAP distinguished name. For example, CN=Jeff Smith,OU=Sales,DC=Fabrikam,DC=COM.
     */
    PiiKind[PiiKind["DistinguishedName"] = 1] = "DistinguishedName";
    /**
     * Generic information.
     */
    PiiKind[PiiKind["GenericData"] = 2] = "GenericData";
    /**
     * An IPV4 Internet address. For example, 192.0.2.1.
     */
    PiiKind[PiiKind["IPV4Address"] = 3] = "IPV4Address";
    /**
     * An IPV6 Internet address. For example, 2001:0db8:85a3:0000:0000:8a2e:0370:7334.
     */
    PiiKind[PiiKind["IPv6Address"] = 4] = "IPv6Address";
    /**
     * The Subject of an e-mail message.
     */
    PiiKind[PiiKind["MailSubject"] = 5] = "MailSubject";
    /**
     * A telephone number.
     */
    PiiKind[PiiKind["PhoneNumber"] = 6] = "PhoneNumber";
    /**
     * A query string.
     */
    PiiKind[PiiKind["QueryString"] = 7] = "QueryString";
    /**
     * An SIP (Session Internet Protocol) address.
     */
    PiiKind[PiiKind["SipAddress"] = 8] = "SipAddress";
    /**
     * An e-mail address.
     */
    PiiKind[PiiKind["SmtpAddress"] = 9] = "SmtpAddress";
    /**
     * An user ID.
     */
    PiiKind[PiiKind["Identity"] = 10] = "Identity";
    /**
     * A URI (Uniform Resource Identifier).
     */
    PiiKind[PiiKind["Uri"] = 11] = "Uri";
    /**
     * The fully-qualified domain name.
     */
    PiiKind[PiiKind["Fqdn"] = 12] = "Fqdn";
})(PiiKind || (PiiKind = {}));
/**
 * Represents the rings that are defined for the Microsoft 365 product.
 */
export var Microsoft365Ring;
(function (Microsoft365Ring) {
    /**
     * Ring for test applications. Not to be used in real applications.
     */
    Microsoft365Ring["test"] = "test";
    /**
     * Inner ring for a limited set of Microsoft employees. Often called DF.
     */
    Microsoft365Ring["inner"] = "inner";
    /**
     * Outer ring for Microsoft employees or equivalent. Often called MSIT or
     * prodbubble.
     */
    Microsoft365Ring["outer"] = "outer";
    /**
     * Ring for all Microsoft employees and a limited set of customers. Often
     * called first release.
     */
    Microsoft365Ring["insiders"] = "insiders";
    /**
     * Ring for all Microsoft employees and all customers. Often called PROD or
     * production.
     */
    Microsoft365Ring["generalAudience"] = "generalAudience";
})(Microsoft365Ring || (Microsoft365Ring = {}));
export var RefinerSelectionType;
(function (RefinerSelectionType) {
    RefinerSelectionType["Select"] = "Select";
    RefinerSelectionType["Deselect"] = "Deselect";
})(RefinerSelectionType || (RefinerSelectionType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9nZ2luZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9sb2dnaW5nLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXVCQTs7R0FFRztBQUNILE1BQU0sQ0FBTixJQUFZLE9BcURYO0FBckRELFdBQVksT0FBTztJQUNqQjs7T0FFRztJQUNILHlDQUFVLENBQUE7SUFDVjs7T0FFRztJQUNILCtEQUFxQixDQUFBO0lBQ3JCOztPQUVHO0lBQ0gsbURBQWUsQ0FBQTtJQUNmOztPQUVHO0lBQ0gsbURBQWUsQ0FBQTtJQUNmOztPQUVHO0lBQ0gsbURBQWUsQ0FBQTtJQUNmOztPQUVHO0lBQ0gsbURBQWUsQ0FBQTtJQUNmOztPQUVHO0lBQ0gsbURBQWUsQ0FBQTtJQUNmOztPQUVHO0lBQ0gsbURBQWUsQ0FBQTtJQUNmOztPQUVHO0lBQ0gsaURBQWMsQ0FBQTtJQUNkOztPQUVHO0lBQ0gsbURBQWUsQ0FBQTtJQUNmOztPQUVHO0lBQ0gsOENBQWEsQ0FBQTtJQUNiOztPQUVHO0lBQ0gsb0NBQVEsQ0FBQTtJQUNSOztPQUVHO0lBQ0gsc0NBQVMsQ0FBQTtBQUNYLENBQUMsRUFyRFcsT0FBTyxLQUFQLE9BQU8sUUFxRGxCO0FBdVhEOztHQUVHO0FBQ0gsTUFBTSxDQUFOLElBQVksZ0JBNEJYO0FBNUJELFdBQVksZ0JBQWdCO0lBQzFCOztPQUVHO0lBQ0gsaUNBQWEsQ0FBQTtJQUViOztPQUVHO0lBQ0gsbUNBQWUsQ0FBQTtJQUVmOzs7T0FHRztJQUNILG1DQUFlLENBQUE7SUFFZjs7O09BR0c7SUFDSCx5Q0FBcUIsQ0FBQTtJQUVyQjs7O09BR0c7SUFDSCx1REFBbUMsQ0FBQTtBQUNyQyxDQUFDLEVBNUJXLGdCQUFnQixLQUFoQixnQkFBZ0IsUUE0QjNCO0FBb0RELE1BQU0sQ0FBTixJQUFZLG9CQUdYO0FBSEQsV0FBWSxvQkFBb0I7SUFDOUIseUNBQWlCLENBQUE7SUFDakIsNkNBQXFCLENBQUE7QUFDdkIsQ0FBQyxFQUhXLG9CQUFvQixLQUFwQixvQkFBb0IsUUFHL0IifQ==